export default {
  setEudrBatches: (state, eudrBatches) => (state.eudrBatches = eudrBatches),
  setLoading: (state, loading) => (state.loading = loading)
}
